const dropdown = document.getElementById('chapter-dropdown');
const mobileMenu = document.getElementById('mobile-sticky-menu');
let menuFixedPoint = '';

window.addEventListener("DOMContentLoaded", function() {
    if(window.location.hash) {
        _scroll(window.location.hash);
    }
});

document.body.addEventListener('click', (e) => {
    let parentDropdown = e.target.closest('.chapter-dropdown');

    if(e.target.classList.contains('dropdown-click-area') && parentDropdown.classList.contains('closed')) {
        openDropdown(parentDropdown);
    } else {
        closeDropdown(e.target, parentDropdown);
    }
});

document.addEventListener('scroll', (e) => {
    stickyMenuDesktop();
    menuHighlight('desktop-menu');
    menuHighlight('mobile-sticky-menu');
    
    let tocScrollPoint = document.querySelectorAll('.toc')[0].getBoundingClientRect().top + document.querySelectorAll('.toc')[0].offsetHeight;

    if (tocScrollPoint < 140) {
        showMobileMenu(mobileMenu);
    } else {
        hideMobileMenu(mobileMenu);
    }
});

function openDropdown(dropdown) {
    dropdown.querySelectorAll('.menu-symbol')[0].classList.remove('fa-chevron-down');
    dropdown.querySelectorAll('.menu-symbol')[0].classList.add('fa-chevron-up');
    dropdown.classList.add('open');
    dropdown.classList.remove('closed');
}

function closeDropdown(target, dropdown) {
    if (target.classList.contains('toc-scroll-link') ) {
        let section = '';

        if(target.dataset.section) {
            section = target.dataset.section;
        } else if(target.parentNode.dataset.section) {
            section = target.parentNode.dataset.section;
        }

        _scroll(section);
    }
    
    if(dropdown) {
        dropdown.querySelectorAll('.menu-symbol')[0].classList.remove('fa-chevron-up');
        dropdown.querySelectorAll('.menu-symbol')[0].classList.add('fa-chevron-down');
        dropdown.classList.add('closed');
        dropdown.classList.remove('open');
    }
}

function _scroll(sectionName) {

    let menuHeight = document.querySelectorAll('#mobile-sticky-menu .chapter-item')[0].offsetHeight;

    if(menuHeight === 0 && window.innerWidth <= 576) { // xs
        menuHeight = 230; //offset of the mobile dropdown + menu
    } else if(menuHeight === 0 && (window.innerWidth > 576 && window.innerWidth <= 768) ) { // sm
        menuHeight = 88;
    }

    const element = document.getElementById(sectionName.replace('#', ''));
    const headerOffset = document.querySelectorAll('.nav-main-container')[0].offsetHeight + menuHeight;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition - headerOffset;
    
    window.scrollBy({
        top: offsetPosition,
        behavior: "smooth"
    });
}

function stickyMenuDesktop() {
    const deskTopMenu   = document.getElementById('desktop-menu');
    const widthVal      = deskTopMenu.getBoundingClientRect().width;
    const chapterWrap   = document.querySelectorAll('.chapters');
    const bottomHeight  = document.querySelectorAll('.background-blue1')[0].offsetHeight + document.querySelectorAll('.footer')[0].offsetHeight;

    if (chapterWrap[0].getBoundingClientRect().top < 80 && chapterWrap[0].getBoundingClientRect().bottom > (bottomHeight - 160)) {
        deskTopMenu.classList.add('fixed-menu');
        deskTopMenu.classList.remove('relative-menu');
        deskTopMenu.style.top = '150px';
        deskTopMenu.style.width = widthVal+'px';
    } else if (chapterWrap[0].getBoundingClientRect().bottom <= (bottomHeight + 80) ) {
        deskTopMenu.classList.add('relative-menu');
        deskTopMenu.classList.remove('fixed-menu');
        deskTopMenu.style.top = (chapterWrap[0].offsetHeight - deskTopMenu.offsetHeight - 160) + 'px';
    } else {
        deskTopMenu.classList.remove('fixed-menu');
        deskTopMenu.classList.remove('relative-menu');
        deskTopMenu.style.top = '';
    }
}

function menuHighlight(menuId) {
    const menuItems = document.getElementById(menuId).querySelectorAll('.toc-scroll-link');

    menuItems.forEach((el) => {
        if(!el.dataset.section) {
            return;
        }

        let ele = document.querySelectorAll(el.dataset.section);

        // we need to get the height of the header and hero so we can caluclate the offset properly
        const headerOffset = window.innerHeight - (document.querySelectorAll('.nav-main')[0].offsetHeight 
                                + document.querySelectorAll('#mobile-sticky-menu')[0].offsetHeight);

        if(window.scrollY > (ele[0].offsetTop + headerOffset - 36) 
        && window.scrollY <= ((ele[0].offsetTop + headerOffset - 36) + ele[0].offsetHeight)) {
            
            if(menuId === 'mobile-sticky-menu') {
                el.parentElement.parentElement.querySelectorAll('.visible-title .number')[0].textContent = el.dataset.number;
                el.parentElement.parentElement.querySelectorAll('.visible-title .h4')[0].textContent = el.dataset.chapterTitle;
            }

            el.classList.add('active');
        } else {
            el.classList.remove('active');
        }
    });
}

function showMobileMenu(mobileMenu) {
    mobileMenu.classList.remove('hidden');
}

function hideMobileMenu(mobileMenu) {
    mobileMenu.classList.add('hidden');
}
